import { Autocomplete, TextField, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useTheme } from "@emotion/react";

const SelectPaymentMethod = ({ onSelect, ...props }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPaymentMethods = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/quickbooks/payment-methods`, data);

      setPaymentMethods(response.data.paymentMethods);
    } catch (error) {
      console.log("Failed To Load Payment Methods");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getPaymentMethods();
  }, []);

  return (
    <>
      <Autocomplete
        loading={loading}
        fullWidth={isSmallScreen}
        // disablePortal
        onChange={(Event, newValue, reason, details) => {
          //   if (reason == "selectOption") setValue(newValue);
          onSelect(newValue);
        }}
        getOptionLabel={(option) => option.Name}
        options={paymentMethods}
        isOptionEqualToValue={(option, value) => {
          if (!value) return false;
          return option.Id === value.Id;
        }}
        renderInput={(params) => (
          <TextField fullWidth {...params} label="Choose payment method" />
        )}
        {...props}
      />
    </>
  );
};

export default SelectPaymentMethod;
